import { render, staticRenderFns } from "./ClientMails.vue?vue&type=template&id=24e4731e"
import script from "./ClientMails.vue?vue&type=script&lang=js"
export * from "./ClientMails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports